import React from 'react';
import { STYLES } from './types';

interface ProductImageProps {
  image: string | undefined;
  productName: string;
}

/**
 * Displays a product image or placeholder when no image is available
 */
const ProductImage: React.FC<ProductImageProps> = ({ image, productName }) => (
  <div style={STYLES.productImage.container} className="me-3">
    {image ? (
      <div className="d-flex align-items-center justify-content-center" style={STYLES.productImage.wrapper}>
        <img 
          src={image} 
          alt={productName} 
          style={STYLES.productImage.img} 
        />
      </div>
    ) : (
      <div 
        className="bg-light d-flex align-items-center justify-content-center"
        style={STYLES.productImage.placeholder}
      >
        <span className="text-muted small">No image</span>
      </div>
    )}
  </div>
);

export default React.memo(ProductImage);
